export default function useFormFilledCalc() {
  // * Calculates the percentage of filled fields in the profile form.
  const calculateProfileFormFilledPercentage = (
    selectedFile,
    updatedProfile
  ) => {
    let totalFields = 8; // Default total fields
    let filledFields = 0;

    if (!updatedProfile) {
      return 0; // Return 0% if no profile data is provided
    }

    // Base fields
    if (updatedProfile.firstName) filledFields++;
    if (updatedProfile.lastName) filledFields++;
    if (updatedProfile.bio) filledFields++;
    if (updatedProfile.age) filledFields++;
    if (updatedProfile.gender) filledFields++;
    if (updatedProfile.jobStatus) filledFields++;
    if (updatedProfile.socialLink) filledFields++;
    if (selectedFile || updatedProfile?.profilePicture) filledFields++;

    // Conditional fields based on job status
    if (updatedProfile.jobStatus === "student") {
      totalFields = 11; // Increase total fields for student
      if (updatedProfile.universityName) filledFields++;
      if (updatedProfile.degreeName) filledFields++;
      if (updatedProfile.GraduationYear) filledFields++;
    } else if (updatedProfile.jobStatus === "employed") {
      totalFields = 11; // Increase total fields for employed
      if (updatedProfile.companyName) filledFields++;
      if (updatedProfile.role) filledFields++;
      if (updatedProfile.desc) filledFields++;
    } else if (updatedProfile.jobStatus === "self-employed") {
      totalFields = 11; // Increase total fields for self-employed
      if (updatedProfile.compName) filledFields++;
      if (updatedProfile.Role) filledFields++;
      if (updatedProfile.description) filledFields++;
    } else if (updatedProfile.jobStatus === "unemployed") {
      totalFields = 9; // Increase total fields for unemployed
      if (updatedProfile.prefRole) filledFields++;
      // No need to increase totalFields here; it was already set to 9
    }

    return Math.round((filledFields / totalFields) * 100); // Calculate percentage
  };

  //   * Calculates the percentage of the main event form that has been filled out.
  const calculateMainEventFormFilledPercentage = (selectedFile, formData) => {
    if (!formData) return 0;

    const requiredFields = [
      "event_name",
      "event_type",
      "organized_by",
      "description",
      "start_date",
      "start_time",
      "end_date",
      "end_time",
      "registration_start_date",
      "registration_start_time",
      "location",
      "venue_type",
      "capacity",
      "image_url",
    ];

    const filledFields = requiredFields.filter(
      (field) => formData[field] || selectedFile
    ).length;

    return Math.round((filledFields / requiredFields.length) * 100);
  };

  return {
    calculateProfileFormFilledPercentage,
    calculateMainEventFormFilledPercentage,
  };
}
